module.exports = __webpack_public_path__ + "img/waracademy_tech_Normal_ua.4f599b01.webp";